import {
  BillingFrequency,
  ContractPlanStatus,
  ContractPlanType,
  ContractStatus,
} from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/contracts_pb";

export const contractStatusToString: Record<ContractStatus, string> = {
  [ContractStatus.UNSPECIFIED]: "Unspecified",
  [ContractStatus.ACTIVATED]: "Activated",
  [ContractStatus.CANCELED]: "Canceled",
  [ContractStatus.EXPIRED]: "Expired",
  [ContractStatus.PAST_DUE]: "Past Due",
  [ContractStatus.TRIALING]: "Trialing",
  [ContractStatus.TRIAL_ENDED]: "Trial Ended",
};

export const contractBillingFreqToString = {
  [BillingFrequency.BILLING_FREQUENCY_UNSPECIFIED]: "Unspecified",
  [BillingFrequency.BILLING_FREQUENCY_MONTHLY]: "Monthly",
  [BillingFrequency.BILLING_FREQUENCY_QUARTERLY]: "Quarterly",
  [BillingFrequency.BILLING_FREQUENCY_SEMI_ANNUAL]: "Semi-Annual",
  [BillingFrequency.BILLING_FREQUENCY_ANNUAL]: "Annual",
  [BillingFrequency.BILLING_FREQUENCY_24_MONTHS]: "24 Months",
  [BillingFrequency.BILLING_FREQUENCY_36_MONTHS]: "36 Months",
};

export const contractBillingFreqMap = {
  [BillingFrequency.BILLING_FREQUENCY_UNSPECIFIED]: 0,
  [BillingFrequency.BILLING_FREQUENCY_MONTHLY]: 1,
  [BillingFrequency.BILLING_FREQUENCY_QUARTERLY]: 3,
  [BillingFrequency.BILLING_FREQUENCY_SEMI_ANNUAL]: 6,
  [BillingFrequency.BILLING_FREQUENCY_ANNUAL]: 12,
  [BillingFrequency.BILLING_FREQUENCY_24_MONTHS]: 24,
  [BillingFrequency.BILLING_FREQUENCY_36_MONTHS]: 36,
};

export const contractBillingFreqMonthList = [
  [BillingFrequency.BILLING_FREQUENCY_UNSPECIFIED, 0],
  [BillingFrequency.BILLING_FREQUENCY_MONTHLY, 1],
  [BillingFrequency.BILLING_FREQUENCY_QUARTERLY, 3],
  [BillingFrequency.BILLING_FREQUENCY_SEMI_ANNUAL, 6],
  [BillingFrequency.BILLING_FREQUENCY_ANNUAL, 12],
  [BillingFrequency.BILLING_FREQUENCY_24_MONTHS, 24],
  [BillingFrequency.BILLING_FREQUENCY_36_MONTHS, 36],
];

export const contractPlanTypeToString: Record<ContractPlanType, string> = {
  [ContractPlanType.PLAN_TYPE_UNSPECIFIED]: "Unknown",
  [ContractPlanType.PLAN_TYPE_SC_SUBSCRIPTION]: "SafetyCulture",
  [ContractPlanType.PLAN_TYPE_IOT_SUBSCRIPTION]: "IoT",
};

export const contractPlanStatusToString: Record<ContractPlanStatus, string> = {
  [ContractPlanStatus.PLAN_STATUS_UNSPECIFIED]: "Unspecified",
  [ContractPlanStatus.PLAN_STATUS_ACTIVE]: "Active",
  [ContractPlanStatus.PLAN_STATUS_CANCELED]: "Canceled",
  [ContractPlanStatus.PLAN_STATUS_PAST_DUE]: "Past Due",
  [ContractPlanStatus.PLAN_STATUS_TRIALING]: "Trialing",
  [ContractPlanStatus.PLAN_STATUS_TRIAL_ENDED]: "Trial Ended",
};

export const ENTERPRISE_PLAN_DOC_LINK =
  "https://safetyculture.atlassian.net/wiki/spaces/BI/pages/2844491822/Checking+if+an+org+has+enterprise+plan";
